import { createBrowserRouter, redirect } from 'react-router-dom';

import SmartHome from '@/components/SmartHome';
import { ChromeExtensionPage } from '@/pages/ChromeExtension';
import CookiePolicy from '@/pages/CookiePolicy';
import Download from '@/pages/Download/index';
import { DownloadDev } from '@/pages/DownloadDev';
import Home from '@/pages/Home';
import HomeCN from '@/pages/HomeCN';
import { OAuthPage } from '@/pages/OAuth';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermOfUse from '@/pages/TermOfUse';
import WaitList from '@/pages/WaitList';
import ForgotPasswordPage from '@/pages/forgot-password';
import Login from '@/pages/login';
import { Main } from '@/pages/main';
import RegisterPage from '@/pages/register';

/**
 * 应用路由配置
 * 使用React Router v6的createBrowserRouter创建路由
 */
// 获取 basename，支持环境变量配置，默认为 cn 开头
const getBasename = () => {
  return import.meta.env.VITE_BASE_NAME || '/';
};

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Main />,
      children: [
        {
          index: true,
          element: <SmartHome />,
        },

        {
          path: '/policies/privacy-policy',
          element: <PrivacyPolicy />,
        },
        {
          path: '/policies/cookie-policy',
          element: <CookiePolicy />,
        },
        {
          path: '/policies/terms-of-use',
          element: <TermOfUse />,
        },
      ],
    },
    // {
    //   path: '/download/dev',
    //   element: <DownloadDev />,
    // },
    {
      path: '/download',
      element: <Download />,
    },
    {
      path: '/waitlist',
      element: <WaitList />,
    },
    {
      path: '/oauth',
      element: <OAuthPage></OAuthPage>,
    },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/login-fail',
      element: <Login />,
    },
    {
      path: '/register',
      element: <RegisterPage />,
    },
    {
      path: '/forgot-password',
      element: <ForgotPasswordPage />,
    },
    {
      path: '/chrome-extension',
      element: <ChromeExtensionPage />,
    },
    // 重定向所有未匹配的路由到登录页
    {
      path: '*',
      loader: () => redirect('/'),
    },
  ],
  {
    basename: getBasename(),
  },
);
